import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-32434da9"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex-1 pb-8" };
const _hoisted_2 = { class: "bg-white shadow" };
const _hoisted_3 = { class: "px-4 sm:px-6 lg:max-w-6xl lg:mx-auto lg:px-8" };
const _hoisted_4 = { class: "py-6 md:flex md:items-center md:justify-between" };
const _hoisted_5 = { class: "flex-1 min-w-0" };
const _hoisted_6 = { class: "flex items-center" };
const _hoisted_7 = { class: "flex items-center" };
const _hoisted_8 = { class: "ml-3 text-2xl font-bold leading-7 text-gray-900 sm:leading-9 sm:truncate" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "mt-6 flex space-x-3 md:mt-0 md:ml-4" }, null, -1));
const _hoisted_10 = { class: "mt-8" };
const _hoisted_11 = { class: "max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 shadow rounded-md py-5" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "text-lg leading-6 font-medium text-gray-900" }, "Overview", -1));
const _hoisted_13 = { class: "mt-2 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" };
const _hoisted_14 = { class: "p-5" };
const _hoisted_15 = { class: "flex items-center" };
const _hoisted_16 = { class: "flex-shrink-0" };
const _hoisted_17 = { class: "ml-5 w-0 flex-1" };
const _hoisted_18 = { class: "text-sm font-medium text-gray-500 truncate" };
const _hoisted_19 = { class: "text-lg font-medium text-gray-900" };
const _hoisted_20 = { key: 0 };
const _hoisted_21 = {
    class: "max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 shadow rounded-md mt-5",
    style: { "min-height": "850px" }
};
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "text-lg leading-6 font-medium text-gray-900 pt-5" }, "\n            Recent Assigned Documents\n          ", -1));
const _hoisted_23 = { class: "flex flex-col mt-2" };
const _hoisted_24 = { class: "align-middle min-w-full overflow-x-auto overflow-hidden sm:rounded-lg" };
const _hoisted_25 = { class: "px-7 py-3" };
const _hoisted_26 = { class: "mt-1 relative rounded-md" };
const _hoisted_27 = { class: "px-7 py-3" };
const _hoisted_28 = { class: "mt-1 relative rounded-md" };
const _hoisted_29 = { key: 0 };
const _hoisted_30 = { class: "mt-5 text-center" };
const _hoisted_31 = { key: 1 };
const _hoisted_32 = { key: 2 };
const _hoisted_33 = { class: "mt-5 text-center" };
const _hoisted_34 = { key: 3 };
const _hoisted_35 = { class: "max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 shadow rounded-md" };
const _hoisted_36 = {
    class: "bg-white px-4 py-3 flex items-center justify-between overflow-hidden border-t border-gray-200 sm:px-6",
    "aria-label": "Pagination"
};
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "hidden sm:block" }, null, -1));
const _hoisted_38 = { class: "flex-1 flex justify-between sm:justify-end" };
const _hoisted_39 = ["disabled"];
const _hoisted_40 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_avatar_ui = _resolveComponent("avatar-ui");
    const _component_DocumentTextIcon = _resolveComponent("DocumentTextIcon");
    const _component_document_cards = _resolveComponent("document-cards");
    return (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_avatar_ui, {
                                        size: "md",
                                        username: _ctx.username
                                    }, null, 8, ["username"]),
                                    _createTextVNode(),
                                    _createElementVNode("h1", _hoisted_8, "\n                    Welcome, " + _toDisplayString(_ctx.username), 1)
                                ])
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    _hoisted_9
                ])
            ])
        ]),
        _createTextVNode(),
        _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (card) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: card.name,
                            class: "bg-white overflow-hidden shadow rounded-lg"
                        }, [
                            _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                        (_openBlock(), _createBlock(_resolveDynamicComponent(card.icon), {
                                            class: "h-6 w-6 text-gray-400",
                                            "aria-hidden": "true"
                                        }))
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("dl", null, [
                                            _createElementVNode("dt", _hoisted_18, _toDisplayString(card.name), 1),
                                            _createTextVNode(),
                                            _createElementVNode("dd", null, [
                                                _createElementVNode("div", _hoisted_19, [
                                                    _createTextVNode(_toDisplayString(card.amount) + " ", 1),
                                                    (card.amount >= 25)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_20, "+"))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ])
                        ]));
                    }), 128))
                ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                            _withDirectives(_createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "searchQueryAssigned",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.searchQueryAssigned) = $event)),
                                        type: "text",
                                        name: "searchQueryAssigned",
                                        class: "px-3 py-4 placeholder-slate-300 text-slate-600 block w-full pl-4 sm:text-sm border-none rounded-md",
                                        placeholder: "Search by short ID..."
                                    }, null, 512), [
                                        [_vModelText, _ctx.searchQueryAssigned]
                                    ])
                                ])
                            ], 512), [
                                [_vShow, _ctx.selected.title === 'Assigned to you']
                            ]),
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "searchQueryCreated",
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.searchQueryCreated) = $event)),
                                        type: "text",
                                        name: "searchQueryCreated",
                                        class: "px-3 py-4 placeholder-slate-300 text-slate-600 block w-full pl-4 sm:text-sm border-none rounded-md",
                                        placeholder: "Search by short ID..."
                                    }, null, 512), [
                                        [_vModelText, _ctx.searchQueryCreated]
                                    ])
                                ])
                            ], 512), [
                                [_vShow, _ctx.selected.title === 'Created by you']
                            ])
                        ])
                    ]),
                    _createTextVNode(),
                    (_ctx.allUserDocuments?.length === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                            _withDirectives(_createVNode(_component_DocumentTextIcon, { class: "w-24 h-24 flex-shrink-0 mx-auto text-gray-400" }, null, 512), [
                                [_vShow, _ctx.selected.title === 'Assigned to you']
                            ]),
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("h1", _hoisted_30, "\n              You currently have no documents assigned to you\n            ", 512), [
                                [_vShow, _ctx.selected.title === 'Assigned to you']
                            ])
                        ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_31, [
                            _withDirectives(_createVNode(_component_document_cards, {
                                "all-documents": _ctx.paginatedResults,
                                userprofile: _ctx.userprofile
                            }, null, 8, ["all-documents", "userprofile"]), [
                                [_vShow, _ctx.selected.title === 'Assigned to you']
                            ])
                        ])),
                    _createTextVNode(),
                    (_ctx.allUserRequests?.length === 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_32, [
                            _withDirectives(_createVNode(_component_DocumentTextIcon, { class: "w-24 h-24 flex-shrink-0 mx-auto text-gray-400" }, null, 512), [
                                [_vShow, _ctx.selected.title === 'Created by you']
                            ]),
                            _createTextVNode(),
                            _withDirectives(_createElementVNode("h1", _hoisted_33, "\n              You have not created any documents\n            ", 512), [
                                [_vShow, _ctx.selected.title === 'Created by you']
                            ])
                        ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_34, [
                            _withDirectives(_createVNode(_component_document_cards, {
                                "all-documents": _ctx.paginatedResults,
                                userprofile: _ctx.userprofile
                            }, null, 8, ["all-documents", "userprofile"]), [
                                [_vShow, _ctx.selected.title === 'Created by you']
                            ])
                        ]))
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("nav", _hoisted_36, [
                        _hoisted_37,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("button", {
                                class: "relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-green-700 bg-white hover:bg-gray-50 disabled:opacity-25 disabled:text-gray-600 disabled:cursor-not-allowed",
                                disabled: _ctx.disablePrevious,
                                onClick: _cache[2] || (_cache[2] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleClickPrevPage && _ctx.handleClickPrevPage(...args)))
                            }, "\n                Previous\n              ", 8, _hoisted_39),
                            _createTextVNode(),
                            _createElementVNode("button", {
                                class: "ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-green-700 bg-white hover:bg-gray-50 disabled:opacity-25 disabled:text-gray-600 disabled:cursor-not-allowed",
                                disabled: _ctx.disableNext,
                                onClick: _cache[3] || (_cache[3] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleClickNextPage && _ctx.handleClickNextPage(...args)))
                            }, "\n                Next\n              ", 8, _hoisted_40)
                        ])
                    ])
                ])
            ])
        ])
    ]));
}
